import ApplicationSerializer from 'eflex/serializers/application';

export default class WieConfigTextSerializer extends ApplicationSerializer {
  attrs = {
    font: {
      embedded: 'always',
    },
    stroke: {
      embedded: 'always',
    },
    background: {
      embedded: 'always',
    },
    textBackground: {
      embedded: 'always',
    },
  };
}
